import '../index.scss';
import * as busyCounter from '../../shared/action-creator/busy-counter';
import React, { Component } from 'react';
import { createErrorMessage, createSuccessMessage } from '../../shared/action-creator/alert-messages';
import { getClaimDetails, updateClaimDataByMode } from '../repositories';
import BusyCounterLoadingIndicator from '../../shared/components/busyCounter/busy-counter-loading-indicator';
import LabeledTextarea from '../../shared/components/labeled-textarea';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getFieldValue } from '../../shared/services/common-functions';
import { showLoadingIndicator } from '../../shared/state/busy-counter';


class ClaimAnalysis extends Component {

    state = {
        claimDetails: {},
        claimComments: '',
    };


    componentWillMount = () => {

        this.loadDefault( this.props.claimNumber );

    }

    componentWillReceiveProps ( nextProps ) {

        if ( nextProps.claimNumber !== this.props.claimNumber ) {

            this.loadDefault( nextProps.claimNumber );

        }

    }

    updateState = ( name, val ) => {

        this.setState( {
            [name]: val,
        } );

    }

    loadDefault = warrantyClaimId => {


        getClaimDetails( this.props.claimFor, warrantyClaimId ).then( response => {

            if ( response.length > 0 ) {

                this.setState( {
                    claimDetails: response[0],
                    claimComments: getFieldValue( response[0].primePartDetailText ),
                } );


            } else {

                this.setState( {
                    claimDetails: {},
                    claimComments: '',
                } );

            }


        } ).catch( () => {


        } );

    }


    onEditBtnClicked = () => {

        this.props.enableEditCmp( this.props.claimFor );

    }

    onSaveBtnClicked = () => {

        if ( this.state.claimComments !== this.state.claimDetails.primePartDetailText ) {

            const updatedData = {
                languageCode: '',
                primePartDetailText: this.state.claimComments,
                primePartNumber: this.props.primePartNumber.partNumber.original,
                translationTypeCode: '',
                warrantyClaimId: this.props.claimNumber,
            };
            updateClaimDataByMode( this.props.claimFor, this.props.claimNumber, updatedData )
                .then( () => {

                    this.loadDefault( this.props.claimNumber );
                    this.props.enableEditCmp( this.props.claimFor );

                } ).catch( () => {

                } );

        } else this.onCancelBtnClicked();

    }

    onCancelBtnClicked = () => {

        if ( this.props.enableEditCmp( this.props.claimFor ) ) {

            this.setState( {
                claimComments: getFieldValue( this.state.claimDetails.primePartDetailText ),
            } );

        }

    }

    updatedComment = comment => {

        this.updateState( 'claimComments', comment.target.value );

    };

    render () {

        return (
            <div className="basic-claim">
                <BusyCounterLoadingIndicator busyCounter={this.props.busyCounter} />
                <section className="claim-complaints">
                    <header className={this.props.isComponentEdit ? 'show' : 'hide'}>
                        <h4 className="page-header">
                            <i title="Edit" className={`fa fa-edit ${!this.props.isEdit ? 'show' : 'hide'}`} onClick={this.onEditBtnClicked} />
                            <i className={`fa fa-save ${this.props.isEdit ? 'show' : 'hide'}`} onClick={this.onSaveBtnClicked} />
                            <i className={`fa fa-remove ${this.props.isEdit ? 'show' : 'hide'}`} onClick={this.onCancelBtnClicked} />
                        </h4>
                    </header>
                    <div className="rows">
                        <LabeledTextarea
                            className="claim-details"
                            isEditable={this.props.isEdit}
                            onChange={this.updatedComment}
                            value={this.state.claimComments}
                            label=" "
                        />

                    </div>
                </section>
            </div>
        );

    }

}
ClaimAnalysis.displayName = 'ClaimAnalysis';
ClaimAnalysis.propTypes = {
    claimNumber: PropTypes.string.isRequired,
    claimFor: PropTypes.string.isRequired,
    claimTextEdit: PropTypes.func.isRequired,
    isComponentEdit: PropTypes.bool.isRequired,
    enableEditCmp: PropTypes.func,
    isEdit: PropTypes.bool.isRequired,
    busyCounter: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    primePartNumber: PropTypes.object.isRequired,
};
const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter ),
} );
const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
    createSuccessMessage: message => dispatch( createSuccessMessage( message ) ),
    createErrorMessage: message => dispatch( createErrorMessage( message ) ),
} );
export default connect( mapStateToProps, mapDispatchToProps )( ClaimAnalysis );
